import {
    Component,
    OnInit,
    OnDestroy,
    AfterViewInit,
    ViewChild,
    ElementRef
} from "@angular/core";
import { ActivatedRoute, Router, RoutesRecognized } from "@angular/router";
import { Location } from "@angular/common";
import { NotificationsService } from "angular2-notifications";
import { Subject } from "rxjs";
import { takeUntil, tap, filter, map, pairwise, take } from "rxjs/operators";
import { Store } from "@ngrx/store";
import { AppState } from "../../../../app.reducer";
import {
    GetAsOfVersionStartAction,
    GetDocumentVersionDetails,
    DownloadDocument,
    GetDocumentById,
    GetCollaborators,
    GetViewers,
    GetSharedUsersList,
    GetUserCapabilitesOfDocument,
    PublishDocument,
    UnPublishDocument,
    getComments,
    postComment,
    GetActivityLog,
    RequestDocAccess,
    GetRequestDocAccessList,
    GetUnpublishedDocuments,
    ReplaceDocument,
    MarkPublicDocument,
    MarkUnPublicDocument,
    ClearDocDetailsStartAction,
    ApproveTags,
    RejectTags
} from "../_store/resources.actions";
import { DOCUMENT_STATUS } from "../../../../app.constants";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShareDocumentComponent } from '../share-document/share-document.component';
import { NotificationModalComponent } from '../../../common-components/notification-modal/notification-modal.component';
import { TagsDialogComponent } from 'src/app/dialogs/tags-dialog/tags-dialog.component';
import { SuggestTagsDialogComponent } from '../../../../dialogs/suggest-tags-dialog/suggest-tags-dialog.component';
import { CommonService } from "src/app/services/tasks.services";
import { AllDocumentsDialogComponent } from "src/app/dialogs/all-documents-dialog/all-documents-dialog.component";
import { ReplaceDocumentDialogComponent } from "../replace-document-dialog/replace-document-dialog.component";
import { NgxPermissionsService } from "ngx-permissions";
import { BASE_URL } from "src/app/services/Api.service";
import { DocumentPreviewDialogComponent } from '../document-preview-dialog/document-preview-dialog.component'
import { environment } from "src/environments/environment";
import { GetUserCapabilites, ClearAction, ErrorAction } from "src/app/login/store/auth.actions";
import { LoaderHide, LoaderShow } from "src/app/features/loader/store/loader.actions";
import { MatTableDataSource } from '@angular/material';


@Component({
    selector: "document-detail",
    templateUrl: "./document-detail.component.html",
    styleUrls: ["./document-detail.component.scss"]
})
export class DocumentDetailComponent
    implements OnInit, OnDestroy, AfterViewInit {
    documentId;
    versions$;
    document: any = {};
    documentsArray = []
    documentIds = []
    selectedVersion: any = {
        version: "",
        status: "",
        updatedAt: "",
        versionNum: ""
    };
    SelectedVersion = "";
    profilePic;
    hideSelectedVersionLabel = true;
    documentStatus = DOCUMENT_STATUS;
    collaborators$: any;
    viewers$: any;
    userCapability: Array<string> = [];
    documentOwner: string;
    comments: Array<any> = [];
    commentPostPayload: object = {
        type: "document",
        doc_id: "",
        comment: ""
    };
    index;
    commentText: string = '';
    activityLog: Array<any> = [];
    showPublicButton: boolean = true;

    suggestedTags: any = [];
    AccessRequestList: any = []
    previousRoute: string = '';
    docUrl: string;
    previewDoc: boolean = false;
    loggedInUserId: string;

    // comments
    documentCommentFlag: boolean = true;
    publishedDocumentCommentFlag: boolean = false
    AllDocumentCommentFlag: boolean = false

    // tags approval
    displayedColumnsOwner: string[] = ['Tag Name', 'Suggested By', 'Actions'];
    displayedColumnsOthers: string[] = ['Tag Name', 'Suggested By'];
    suggestedTagsToAdd: any = [];
    suggestedTagsToRemove: any = [];
    tagsToAdd: MatTableDataSource<any>;
    tagsToRemove: MatTableDataSource<any>;
    payload: object = { tagIdToAdd: '', tagIdToRemove: '', userId: '' }

    @ViewChild("dataWrapper", { static: false }) dataWrapper: ElementRef;
    private stopper: Subject<any> = new Subject<any>();
    dataWrapperHeight: any;
    hideDocument: boolean = false;
    textInData: string = '';
    permissionsForComment = [];
    isDocumentOwner: boolean = false;
    showSuggestedApproveTags: boolean = false;
    showRejectedApproveTags: boolean = false;
    sourceId: Boolean = false;
    allCMPDocument: boolean = false;
    fromAllCmpTab: boolean = false;
    fromAllFinancialDocs: boolean = false;
    host = environment.host;
    dataLoadDocs: boolean = false;
    citisFolderId: any;
    

    summaryColumns: string[] = ['name', 'version', 'by', 'observations', 'type'];

    constructor(
        private route: ActivatedRoute,
        private notificationService: NotificationsService,
        public location: Location,
        private store: Store<AppState>,
        private dialog: MatDialog,
        public commonService: CommonService,
        private router: Router,
        private ngxPermissionService: NgxPermissionsService,
        public activateRoute: ActivatedRoute
    ) { }

    ngOnInit() {
        this.store.dispatch(new GetUserCapabilites());
        this.store.select(state => state.resources.userCapability).pipe(takeUntil(this.stopper)).subscribe(data => {

            if (Object.keys(data).length) {
                this.dataLoadDocs = true;
            }


            this.hideDocument = data.includes('no_access')

            this.fromAllCmpTab = data.includes("all_cmp")
            this.fromAllFinancialDocs = data.includes("all_financial")
            // this.activateRoute.queryParams.subscribe((resp) => {
            //     if(Object.keys(resp).length) {
            //         if(resp.fromAllCmpDocuments == 'true') {
            //         this.hideDocument =false;
            //         this.allCMPDocument = true;  
            //         }
            //         else {
            //             this.hideDocument = data.includes('no_access')
            //         }

            // }
            // })
            return this.userCapability = data
        });
        this.store.dispatch(new ClearAction())
        this.store.select(state => state.auth).subscribe(auth => {
            this.profilePic = `${environment.host}/user/getImage/${auth.user.details._id}`;
        });

        this.store.select(state => state.auth.user).pipe(take(1)).subscribe(user => {
            this.loggedInUserId = user.details._id;
        });

        this.route.params.pipe(takeUntil(this.stopper)).subscribe(params => {
            this.documentId = params.documentId;
            this.citisFolderId = (params || {}).folderId;
            this.store.dispatch(new LoaderShow());
            this.store.dispatch(new ClearDocDetailsStartAction());
            this.store.dispatch(new GetDocumentById(this.documentId, this.allCMPDocument));
            this.store.dispatch(new GetSharedUsersList(this.documentId));
            this.store.dispatch(new GetUserCapabilitesOfDocument(this.documentId, 'documentDetail'));
            this.store.dispatch(new GetAsOfVersionStartAction(this.documentId));

            //get list of access requested docs
            this.store.select(state => state.resources.docAccessRequestList).subscribe(
                res => {
                    this.AccessRequestList = res
                }
            )

            this.store.select(state => state.resources.docDetail).subscribe(detail => {
                if (Object.keys(detail).length) {
                    this.document = detail;
                    console.log(detail)
                    this.documentId = detail._id;
                    this.getDocumentActivityLog();
                    this.store.dispatch(new LoaderHide());
                    if (+detail.status === 2) {
                        this.publishedDocumentCommentFlag = true;
                    }
                    console.log("loggedInUserId", this.loggedInUserId)
                    this.isDocumentOwner = this.loggedInUserId === detail.ownerId;
                    if (this.isDocumentOwner) {
                        this.store.dispatch(new GetRequestDocAccessList(detail.parentId || this.documentId));
                    }

                    this.selectedVersion.versionNum = detail.versionNum
                    if (detail['suggestTagsToAdd']) {
                        this.suggestedTagsToAdd = []
                        detail['suggestTagsToAdd'].map(data => data.tags.map(tag => {
                            let temp = {}
                            temp['tag'] = tag.tag
                            temp['tagId'] = tag._id
                            temp['user'] = data.user
                            this.suggestedTagsToAdd.push(temp)
                        }))
                        this.tagsToAdd = new MatTableDataSource(this.suggestedTagsToAdd);
                    }
                    if (detail['suggestTagsToRemove']) {
                        this.suggestedTagsToRemove = []
                        detail['suggestTagsToRemove'].map(data => data.tags.map(tag => {
                            let temp = {}
                            temp['tag'] = tag.tag
                            temp['tagId'] = tag._id
                            temp['user'] = data.user
                            this.suggestedTagsToRemove.push(temp)
                        }))
                        this.tagsToRemove = new MatTableDataSource(this.suggestedTagsToRemove);
                    }

                    // if (this.userCapability.includes('owner') && (!this.displayedColumns.includes('Actions')))
                    //     this.displayedColumns.push('Actions')

                    if (detail.suggestTagsToAdd) {
                        detail.suggestTagsToAdd.forEach((element) => {
                            if (element.tags.length > 0) {
                                this.showSuggestedApproveTags = true;
                            } else {
                                this.showSuggestedApproveTags = false;
                            }
                        });
                    }

                    if (detail.suggestTagsToRemove) {
                        detail.suggestTagsToRemove.forEach((element) => {
                            if (element.tags.length > 0) {
                                this.showRejectedApproveTags = true;
                            } else {
                                this.showRejectedApproveTags = false;
                            }
                        });
                    }
                    if (Object.keys(detail).length && (detail.sourceId !== null) && (Object.keys(detail.sourceId).length)) {
                        this.sourceId = true;

                    }
                    else {
                        this.sourceId = false
                    }
                }
            });



            this.collaborators$ = this.store.select(state => state.resources.sharedUsers).pipe(
                map(users => {
                    if (!this.commonService.shareDocsInMessage) {
                        return users.filter((user: any) => (user.docRole === 'collaborator'))
                    }
                }),
            );

            this.viewers$ = this.store.select(state => state.resources.sharedUsers).pipe(
                map(users => users.filter((user: any) => {
                    if (!this.commonService.shareDocsInMessage) {
                        return user.docRole === 'viewer'
                    }
                }
                )),
            );
            this.store.select(state => state.resources.sharedUsers).pipe(
                map(users => users.filter((user: any) => (user.docRole === 'owner')))
            ).subscribe((owner: any) => {
                if (!this.commonService.shareDocsInMessage) {
                    if (owner.length) this.documentOwner = owner[0].name;
                }
            });

            this.versions$ = this.store.select(state => state.resources.asofVersion)

            this.store.dispatch(new getComments(this.document.parentId || this.documentId, 'document'))
            this.store.select(state => state.resources.comments)
                .subscribe(response => {
                    if (Object.keys(response).length) {
                        this.comments = JSON.parse(JSON.stringify(response["comments"]));
                        this.comments.map(comment => {
                            comment.displayPic = `${environment.host}/user/getImage/${comment.user._id}`
                        })
                    }
                },
                    error => {
                        this.store.dispatch(new ErrorAction(error));
                        // console.log(error);
                    }
                );




            // data.products.forEach( (element) => {
            //     element.product_desc = element.product_desc.substring(0,10);
            // });
        });

        /* 
          CODE FOR ACTIVITY LOGS
        */
        this.store.select(state => state.auth.user['capabilities']).subscribe(response => {
            if (response.length) {
                // let capabilities = response[0].capabilities;
                const capabilities = (Object.keys(this.ngxPermissionService.getPermissions()) || []);
                if (capabilities.includes("document-activity-log")) {
                    this.store.dispatch(new GetActivityLog(this.document.parentId || this.documentId));
                    this.store.select(state => state.resources.activityLog).subscribe(response => {
                        this.activityLog = response;
                        this.activityLog.map(item => {
                            // console.log(item);
                            // invoke fn to build descriptive msg for every activity log
                            let logMsg = this.buildActivityLogMsg(item);
                            // push msg to existing object
                            item["logMsg"] = logMsg;
                            item["displayPic"] = `${environment.host}/user/getImage/${item.activityBy}`
                        });
                    });
                }
            }
        })
        // this.store.dispatch(new GetConfigurations());
        // this.store.select(state => state.configurations.configurations).subscribe(resp => console.log(resp, "here"))



    }

    /* 
        @author Pooja Gawas
        Builds customised descriptive messages for every activity log
        @param {Object} activityLog details of an activity log
        @returns {String} Message Customised msg for every activity log
    */
    buildActivityLogMsg(activityLog) {
        let fname = activityLog.activityBy.firstName;
        let mname = activityLog.activityBy.middleName;
        let lname = activityLog.activityBy.lastName;
        let fullname = `${fname} ${mname} ${lname}`;

        function getNamesFromIds(userIdsArr) {
            let namesArr: Array<any> = [];
            let namesStr: string;
            userIdsArr.map(item => {
                if (item.firstName && item.lastName) {
                    namesArr.push(`${item.firstName} ${item.lastName} `);
                } else {
                    namesArr.push(item.name)
                }
            });
            namesStr = namesArr.join();
            return namesStr;
        }

        function getTagName(tagsArr) {
            let namesArr: Array<any> = [];
            let namesStr: string;
            tagsArr.map(item => {
                namesArr.push(item.tag);
            });
            namesStr = namesArr.join();
            return namesStr;
        }

        switch (activityLog.activityType) {
            case 'DOCUMENT_CREATED':
                return `${fullname} created this document `;

            case 'DOCUMENT_UPDATED':
                return `${fullname} updated this document `;

            case 'CANCEL_UPDATED':
                return `${fullname} canceled this document update `;

            case 'TAGS_ADDED':
                return `${fullname} added tags ${getTagName(activityLog.tagsAdded)} to this document `;

            case 'TAGS_REMOVED':
                return `${fullname} removed tags ${getTagName(activityLog.tagsRemoved)} from this document `;

            case 'MODIFIED_USER_SHARED_AS_VIEWER':
                return `${fullname} modified document access from collaborator to viewer for ${getNamesFromIds(activityLog.documentAddedUsers)} `;

            case 'MODIFIED_USER_SHARED_AS_COLLABORATOR':
                return `${fullname} modified document access from viewer to collaborator for ${getNamesFromIds(activityLog.documentAddedUsers)} `;

            case 'MODIFIED_GROUP_SHARED_AS_VIEWER':
                return `${fullname} modified document access from collaborator to viewer for ${getNamesFromIds(activityLog.documentAddedUsers)} group`;

            case 'MODIFIED_GROUP_SHARED_AS_COLLABORATOR':
                return `${fullname} modified document access from viewer to collaborator for ${getNamesFromIds(activityLog.documentAddedUsers)} group`;

            case 'DOCUMENT_SHARED_AS_VIEWER':
                return `${fullname} shared document with ${getNamesFromIds(activityLog.documentAddedUsers)}, with view access`;

            case 'DOCUMENT_SHARED_AS_COLLABORATOR':
                return `${fullname} shared document with ${getNamesFromIds(activityLog.documentAddedUsers)}, with edit access`;

            case 'REMOVED_USER_FROM_DOCUMENT':
                return `${fullname} removed access to this document for ${getNamesFromIds(activityLog.documentRemovedUsers)} `;

            case 'REMOVED_GROUP_FROM_DOCUMENT':
                return `${fullname} removed access to this document for ${getNamesFromIds(activityLog.documentRemovedUsers)} group`;

            case 'DOUCMENT_PUBLISHED':
                return `${fullname} published this document `;

            case 'DOUCMENT_UNPUBLISHED':
                return `${fullname} unpublished this document `;

            case 'DOUCMENT_REPLACED':
                return `${fullname} replaced this document `;

            case 'DOCUMENT_DELETED':
                return `${fullname} deleted this document `;

            case 'DOCUMENT_VIEWED':
                return `${fullname} viewed this document `;

            case 'DOCUMENT_COMMENT':
                return `${fullname} added a comment to this document`;

            case 'DOCUMENT_DOWNLOAD':
                return `${fullname} Dowloaded this document`;

            case "TAGS_ADD_AND_REMOVED":
                return `${fullname} added tags ${getTagName(activityLog.tagsAdded)}
                 to this document and removed tags ${getTagName(activityLog.tagsRemoved)} from this document `;
            case 'NEW_RESPONSE':
                return activityLog.message;
            default:
                return;
        }
    }

    ngAfterViewInit() {
        // this.dataWrapperHeight = ((this.dataWrapper).nativeElement).getBoundingClientRect().height + "px";
    }

    ngOnDestroy() {
        this.stopper.next();
        this.stopper.complete();
    }

    hideversionlabel() {
        this.hideSelectedVersionLabel = false;
    }

    downloadDocument(version) {
        this.store.dispatch(new DownloadDocument(this.documentId, version.fileName, version._id));
        this.getDocumentActivityLog();
    }

    goToShareDocument() {
        const dialogRef = this.dialog.open(ShareDocumentComponent, {
            width: "60%",
            maxHeight: "82%",
            data: {
                documentId: this.document.parentId || this.document._id
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            this.getDocumentActivityLog();
        });
    }

    publishDocument() {
        // const dialogRef = this.dialog.open(NotificationModalComponent, {
        //   width:'40%',
        //   data : {
        //     text : 'Are you sure want to publish this document ? '
        //   }
        // });
        // dialogRef.afterClosed().subscribe(result => {
        //   if (result) {
        //     this.store.dispatch(new PublishDocument(this.documentId));
        //   }
        // });
    }

    unPublishDocument() {
        const dialogRef = this.dialog.open(NotificationModalComponent, {
            width: "40%",
            panelClass: 'cmp-modal',
            data: {
                text: "Are you sure you want to unpublish this document?"
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.store.dispatch(new UnPublishDocument(this.documentId));
            }
        });
    }

    // onVersionSelect(version) {
    //     this.documentId = version._id;
    //     this.store.dispatch(new GetDocumentById(version._id));
    //     this.store.select(state => state.resources.docDetail).subscribe(detail => {
    //         if (Object.keys(detail).length) {
    //             let document = detail;
    //             if (this.documentIds.indexOf(document.versionNum) === -1) {
    //                 this.documentIds.push(document.versionNum)
    //                 this.documentsArray.push(document)
    //             }
    //         }
    //     });
    // }

    addTagClick() {
        this.store.dispatch(new GetDocumentById(this.documentId, this.allCMPDocument));
        const dialog = this.dialog.open(TagsDialogComponent, {
            width: "40%",
            hasBackdrop: true,
            panelClass: "task-detail-modal",
            data: {
                allDetails: this.document,
                type: "documentHub",
                alertTitle: "Add Tag",
                placeHolder: "Add Tag (search with key words)",
                docID: this.documentId,
                allCMPDoc: this.allCMPDocument,
                module: 'doc'

            }
        });
    }

    submitComment(comment) {
        this.commentPostPayload["entity_id"] = this.document.parentId || this.documentId;
        this.commentPostPayload["comment"] = comment;

        this.store.dispatch(new postComment(this.commentPostPayload));
        this.store.select(state => state.resources.comment).subscribe(
            res => {
                this.store.dispatch(new getComments(this.document.parentId || this.documentId, 'document'));
                this.store.select(state => state.resources.comments)
                    .subscribe(
                        response => {
                            this.comments = response["comments"];
                            this.commentText = '';

                            this.comments.map(comment => {
                                comment.displayPic = `${environment.host}/user/getImage/${comment.user._id}`
                            })
                        },
                        error => {

                            // console.log(error);
                        }
                    );
            },
            err => { }
        );
    }

    tabChange(event) { }

    suggestTags(docId: string = '') {
        const dialog = this.dialog.open(SuggestTagsDialogComponent, {
            width: "55%",
            hasBackdrop: true,
            panelClass: "task-detail-modal",
            data: {
                allDetails: this.document,
                type: "documentHub",
                alertTitle: "Suggest Tags",
                placeHolder: "Add Tag (search with key words)",
                docID: this.documentId,
                allCMPDoc: this.allCMPDocument
            }
        });
    }

    // Request Doc Access
    RequestDocAccess() {
        this.store.dispatch(new RequestDocAccess(this.document.parentId || this.documentId));
    }

    replaceDocument() {
        const dialogRef = this.dialog.open(ReplaceDocumentDialogComponent, {
            width: "90%",
            height: "80%",
            hasBackdrop: true,
            panelClass: "task-detail-modal",
            data: {
                alertTitle: "Replace Document"
            }
        })

        dialogRef.afterClosed().subscribe((data) => {
            if (data !== undefined && data && Object.keys(data).length) {
                const params = {
                    id: this.documentId,
                    replaceDocId: data._id
                }
                if(this.router.url.includes('citiis')){
                    this.router.navigate(['home', 'resources', 'citis-replace-doc', params.id, params.replaceDocId,this.citisFolderId]);
                }else{
                this.router.navigate(['home', 'resources', 'replace-doc', params.id, params.replaceDocId]);
                }
                //this.store.dispatch(new ReplaceDocument(params));
            }
        })
    }

    MarkPublicDocument(type) {
        switch (type) {
            case 'mark-public':
                this.textInData = "Are you sure you want to make this document public?";
                break;
            case 'un-public':
                this.textInData = "Are you sure you want to revoke public access to this document?"
        }
        const dialogRef = this.dialog.open(NotificationModalComponent, {
            width: "40%",
            panelClass: 'cmp-modal',
            data: {
                text: this.textInData
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                if (type === 'mark-public') {
                    this.store.dispatch(new MarkPublicDocument(this.documentId));
                } else if (type === 'un-public') {
                    // code for un-public
                    this.store.dispatch(new MarkUnPublicDocument(this.documentId))
                }
            }
        });
    }

    previewDocument(version) {
        let documentId = version._id;
        this.store.dispatch(new GetDocumentById(version._id));
        let document
        this.store.select(state => state.resources.docDetail).subscribe(detail => {
            if (Object.keys(detail).length) {
                document = detail;
            }
        });
        if(document){
            this.previewDoc = true;
            let fileName = document.fileName;
            let imgExtensionsArr = ["jpg", "jpeg", "png"];
            let isImage = false;
    
            if (!environment.production) {
                this.docUrl = `${BASE_URL}/docs/${documentId}/file`;
            } else {
                this.docUrl = `https://${location.host}/api/docs/${documentId}/file`;
            }
    
            if (fileName) {
                var fileNameSplit = fileName.split(".");
                var fileExt = fileNameSplit[fileNameSplit.length - 1];
                if (imgExtensionsArr.indexOf(fileExt.toLowerCase()) != -1) {
                    isImage = true;
                } else {
                    isImage = false;
                }
            }
    
            const dialogref = this.dialog.open(DocumentPreviewDialogComponent, {
                hasBackdrop: true,
                width: '90%',
                height: '90%',
                panelClass: 'cmp-modal',
                data: {
                    docUrl: this.docUrl,
                    isImage: isImage
                }
            })
        }
    }

    onSourceInClick(id) {
        this.router.navigate([`../home/resources/doc/${id}`])
    }

    goBack() {
        if (history.length > 1) {
            this.location.back()
        }
        else {
            this.router.navigate([`../home/resources/me`])
        }
    }

    setDefaultPic(item) {
        if (typeof item == "string" && item == "myDefaultPic") {
            this.profilePic = "assets/images/user_profile.svg";
        }
        else {
            item.displayPic = "assets/images/user_profile.svg"
        }
    }


    getDocumentActivityLog() {
        this.store.select(state => state.auth.user['capabilities']).subscribe(response => {
            if (response.length) {
                // let capabilities = response[0].capabilities;
                const capabilities = (Object.keys(this.ngxPermissionService.getPermissions()) || []);
                if (capabilities.includes("document-activity-log")) {
                    this.store.dispatch(new GetActivityLog(this.document.parentId || this.documentId));
                    this.store.select(state => state.resources.activityLog).subscribe(response => {
                        this.activityLog = response;
                        this.activityLog.map(item => {
                            // console.log(item);
                            // invoke fn to build descriptive msg for every activity log
                            let logMsg = this.buildActivityLogMsg(item);
                            // push msg to existing object
                            item["logMsg"] = logMsg;
                            item["displayPic"] = `${environment.host}/user/getImage/${item.activityBy}`
                        });
                    });
                }
            }
        })
    }

    approveTag(tag, user) {
        this.payload = { tagIdToAdd: tag, userId: user }
        this.store.dispatch(new ApproveTags(this.document.parentId || this.documentId, this.payload))
        this.payload['tagIdToAdd'] = ''
    }

    rejectTag(tag, user) {
        this.payload = { tagIdToAdd: tag, userId: user }
        this.store.dispatch(new RejectTags(this.document.parentId || this.documentId, this.payload))
        this.payload['tagIdToAdd'] = ''

    }

    approveRemovalTag(tag, user) {
        this.payload = { tagIdToRemove: tag, userId: user }
        this.store.dispatch(new ApproveTags(this.document.parentId || this.documentId, this.payload))
        this.payload['tagIdToRemove'] = ''

    }

    rejectRemovalTag(tag, user) {
        this.payload = { tagIdToRemove: tag, userId: user }
        this.store.dispatch(new RejectTags(this.document.parentId || this.documentId, this.payload))
        this.payload['tagIdToRemove'] = ''
    }

    refreshComments() {
        this.store.dispatch(new getComments(this.document.parentId || this.documentId, 'document'))
    }
}